export default class Score {
    constructor(game) {
        this.game = game
        this.color = "#0D2330"
        this.scoreToCount = 0
        this.urovenScore = 0
        this.scoreToDisplay = "00"
        this.pocetPrestige = 0
        this.prestizeHvezdaScale = 0.3
        this.prestizeHvezdaWidth = 70
        this.prestizeHvezdaHeight = 70
        this.prestizeHvezdaStartX = 200
        this.prestizeHvezdaMezera = 10
        this.prestizeHvezdaY = 20
        this.prestizeHvezdaImg = document.getElementById('prestizeHvezda')

        this.x = 90
        this.y = 19
        this.width = 200
        this.height = 157
        this.scale = 0.207
        this.image = document.getElementById('pickupSrdce')

        this.textUrovne = document.getElementById('textScoreLevel').textContent
    }
    // eslint-disable-next-line no-unused-vars
    update(deltaTime) {
        let zaokrouhleneScore = this.game.srdickaScore
        if(zaokrouhleneScore <= 9) {
            this.scoreToDisplay = "0" + zaokrouhleneScore
        } else if(zaokrouhleneScore <= 99) {
            this.scoreToDisplay = "" + zaokrouhleneScore
        } else if(zaokrouhleneScore >= 100) {
            this.scoreToCount = 0
            this.pocetPrestige++
        }
        if(this.game.srdickaScore > 0 && this.game.srdickaScore <= 7) {
            this.urovenScore = 1
        } else if (this.game.srdickaScore > 7 && this.game.srdickaScore <= 20) {
            this.urovenScore = 2
        } else if (this.game.srdickaScore > 20 && this.game.srdickaScore <= 45) {
            this.urovenScore = 3
        } else if (this.game.srdickaScore > 45 && this.game.srdickaScore <= 80) {
            this.urovenScore = 4
        } else if (this.game.srdickaScore > 80) {
            this.urovenScore = 5
        }
    }
    draw(context) {
        context.globalAlpha = 1

        for(let i = 0; i < this.pocetPrestige; i++) {
            context.drawImage(this.prestizeHvezdaImg, 0, 0, this.prestizeHvezdaWidth, this.prestizeHvezdaHeight, this.prestizeHvezdaStartX + (this.prestizeHvezdaWidth * this.prestizeHvezdaScale * i) + (this.prestizeHvezdaMezera * i), this.prestizeHvezdaY, this.prestizeHvezdaWidth * this.prestizeHvezdaScale, this.prestizeHvezdaHeight * this.prestizeHvezdaScale)
        }

        context.fillStyle = this.color;

        context.beginPath();

        context.moveTo(0, 0);
        context.lineTo(220, 0);
        context.lineTo(100, 108);
        context.lineTo(0, 100);
        context.closePath();

        context.fill();

        context.font = "800 20px TeleNeoLocalExtraBold"
        context.textAlign = "start"
        context.strokeStyle = "#FFFFFF"
        context.lineWidth = 0

        context.fillStyle = "#FFFFFF"
        context.fillText(this.textUrovne + " " + this.urovenScore, 20, 80)

        context.font = "800 50px TeleNeoLocalExtraBold"
        context.textAlign = "start"
        context.fillText(this.scoreToDisplay, 20, 50)

        context.drawImage(this.image, 0, 0, this.width, this.height, this.x, this.y, this.width * this.scale, this.height * this.scale)
    }
}